import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    filterFieldsData: []
}
const StaffFilterSlice = createSlice({
    name: 'staffFilterFields',
    initialState,
    reducers: {
        handleStaffFilterData(state, action) {
            state.filterFieldsData = action.payload

        }
    }
})
export const { handleStaffFilterData } = StaffFilterSlice?.actions
export default StaffFilterSlice.reducer